exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_listTitle__2-j_A{font-size:1.063rem;line-height:1.18rem;color:#2f93e0;margin:.25rem 0;font-weight:500}", ""]);

// exports
exports.locals = {
	"listTitle": "style_listTitle__2-j_A"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/ListTitle/style.less
// module id = 1802
// module chunks = 8